module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-01.f37919e9.png";